<div class="seed-return-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      View Release Breakdown
    </h3>
  </div>
  <div class="row margin-l0 margin-r0">
    <div class="col-md-12 tabBgColor padding-t10 padding-l30">
      <div class="row">
        <div class="col-md-2"><h6>Release Qty: {{releaseOrderItem.releaseQty}}</h6></div>
        <div class="col-md-10"></div>
        <div class="col-md-2">
          <h6>Total Inventory: {{quantityAvailability}}</h6>
        </div>
        <div class="col-md-6">
          <h6>Branch Plant: {{branchPlantData.id}} - {{branchPlantData.value}}</h6>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-l0 margin-r0">
    <div class="tableContainer dealertableContainer table-mobile">
      <table mat-table [dataSource]="seedFulfillmentBreakdownLotsDS" class="matTables">
        <ng-container matColumnDef="itemDescription">
          <th mat-header-cell *matHeaderCellDef class="shipToLocation">Item</th>
          <td mat-cell *matCellDef="let element">
            <div>
              <p class="blueText margin-b0"> {{element.brand}} - {{element.marketingBrand}} {{space3}} [{{element.itemNumber}}]</p>
              <p class="grower-name lightBlueText">
                {{element.itemDescription}}
              </p>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="lot">
          <th mat-header-cell *matHeaderCellDef class="webOrderNumber text-center">Lot</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.lot}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef class="orderCreateDate  text-center">
            Location
          </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.location}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="memoLot1">
          <th mat-header-cell *matHeaderCellDef class="accountNumber  text-center">Memo Lot 1</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.memoLot1}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="memoLot2">
          <th mat-header-cell *matHeaderCellDef class="locationDetails text-center"> Memo Lot 2 </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.memoLot2}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="quantityAvailable">
          <th mat-header-cell *matHeaderCellDef class="status text-center ">Inventory</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.quantityAvailable}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef class="status text-center ">Weight</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="margin-t-15">
              {{element.weight}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lotLocationReleaseQuantity">
          <th mat-header-cell *matHeaderCellDef class="locationDetails text-center">Lot/Location Release Qty</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div *ngIf="isViewOrEdit=='V'" class="margin-t-15">
              {{element.lotLocationReleaseQuantity}}
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="seedFulfillmentBreakdownColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: seedFulfillmentBreakdownColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="seedFulfillmentBreakdownFootersColumns; sticky: true"></tr>
      </table>
      <div *ngIf="seedFulfillmentBreakdownLotsDS == undefined || seedFulfillmentBreakdownLotsDS?.data.length == 0" class="noDataMsg">
        <p class="padding-b47">No Record Found.</p>
      </div>
      <div class="row add-order-sec margin-l0 margin-r0 position-fixed">
        <div class="col-md-2 padding-l10">
          <button *ngIf="isViewOrEdit=='V'" id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" (click)="returnToRelease()">Return to Release</button>
        </div>
      </div>
    </div>
  </div>
</div>
